module.exports = __webpack_public_path__ + "static/media/icon_179.4f80db66.svg";